'use strict';

(function(window, document){
	// ----------------------------------- [START] Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws,
		html = document.documentElement,
		body = document.body;

	// 取得Window設定值
	var windowSetting = function () {
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();
	registerListener('resize', throttle(windowSetting, 50, 100));

	// -----------------------------
	// 取得裝置判斷
	var isMobile = false,
		isTablet = false,
		isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true
		}
	}
	deviceDetect();
	registerListener('resize', throttle(deviceDetect, 50, 100));
	// ----------------------------------- [END] Setting



	/* ----------------------------------- [START] Swiper Tool */
	/*
	 * Swiper Set Tab
	 */
	/** 增加Swiper因設定Loop產生的重複物件不能用Tab Focus
	 * @param {Object} target - 傳入 swiperTargetEl.parentElement，Build Swiper父層
	 */
	function swiperLoopTabRemove(target) {
		setTimeout(() => {
			var swiperLoopCopyItem = target.querySelectorAll('.swiper-slide-duplicate');
			[].forEach.call(swiperLoopCopyItem, function(item) {
				if (item.tagName === 'A') {
					item.setAttribute('tabindex', -1)
				} else {
					var insideLink = item.querySelectorAll('a, button')
					for (let i = 0; i < insideLink.length; i++) {
						insideLink[i].setAttribute('tabindex', -1)
					}
				}
			});
		}, 500);
	}

	function swiperTabFocusChange(swiper) {
		// 如果 Loop 判斷使用 slideToLoop 會有 Bug，無解；僅使用 slideTo 。
		var swiperEl = swiper.$el[0];
		var swiperSlideLinkEl = swiperEl.querySelectorAll('.swiper-slide a');
		[].forEach.call(swiperSlideLinkEl, function(item) {
			var slide = $(item).parents('.swiper-slide').eq(0);
			var elIndex = slide.index();
			item.addEventListener('focus', function() {
				if(!isMobile) {
					swiper.slideTo(elIndex);
					swiper.lazy.loadInSlide(elIndex + 1);
				}
			});
		});

		// 解決Focus後內容會滑動問題
		// https://github.com/nolimits4web/swiper/issues/596#issuecomment-33311830
		var $swiperEl = $(swiperEl);
		$swiperEl.on('keydown keyup', function(e){
			if (e.keyCode==9) {
				$swiperEl[0].scrollLeft = 0;
			}
		});
	}

	var a11y = {
		enabled: true,
		prevSlideMessage: '上一項',
		nextSlideMessage: '下一項',
		firstSlideMessage: '第一項',
		lastSlideMessage: '最後一項',
		paginationBulletMessage: '去第{{index}}項'
	}
	/* ----------------------------------- [END] Swiper Tool */

	/*
		* Carousel
		*/
	var swiper__alert = undefined;
	var buildSwiper__alert = function() {
		var swiperTarget = '#product-list-carousel',
			swiperTargetEl = document.querySelector(swiperTarget),
			swiperEl = swiperTargetEl.parentElement,
			swiperNextEl = swiperEl.querySelector('.swiper-button-next'),
			swiperPrevEl = swiperEl.querySelector('.swiper-button-prev'),
			swiperSlide = swiperTargetEl.querySelectorAll('.swiper-slide'),
			loop = swiperSlide.length > 4;

		/* 設定按鈕 title */
		swiperNextEl.setAttribute('title', a11y.nextSlideMessage);
		swiperPrevEl.setAttribute('title', a11y.prevSlideMessage);

		swiper__alert = new Swiper(swiperTarget, {
			slidesPerView: 4,
			slidesPerGroup: 4,
			a11y: a11y,
			loop: loop,
			watchOverflow: !loop,
			lazy: {
				elementClass: 'lazy',
				loadedClass: 'lazy-loaded'
			},
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			on: {
				init () {
					swiperLoopTabRemove(this.$el[0]);
					swiperTabFocusChange(this);
				}
			}
		});
	}

	// Breakpoint
	var breakpoint__alert = window.matchMedia('(min-width: 1024px)');
	var breakpointChecker__alert = function () {
		if(breakpoint__alert.matches) {
			buildSwiper__alert();
		} else {
			if(swiper__alert !== undefined) swiper__alert.destroy(true, true);
		}
	}

	// Start
	registerListener('load', breakpointChecker__alert);
	breakpoint__alert.addListener(breakpointChecker__alert);

})(window, document);

